(function () {
    "use strict";
    const STORE_KEY = "sarvasuite.theme";
    const root = document.documentElement;
    const body = () => document.body;
    const log = (...a) => { try { console.log("[SarvaSuite/Theme]", ...a); } catch(_){} };

    function applyTheme(theme, persist) {
        root.setAttribute("data-theme", theme);
        root.setAttribute("data-theme-mode", theme);
        if (body()) body().setAttribute("data-theme", theme);
        if (persist !== false) {
            try { localStorage.setItem(STORE_KEY, theme); } catch (e) { log("ls write fail", e); }
        }
        updateToggleIcon(theme);
        log("apply", theme, "persist=" + (persist !== false));
    }

    // ---------- Pre-boot ----------
    try {
        const stored = localStorage.getItem(STORE_KEY);
        const sysDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
        const initial = (stored === "light" || stored === "dark") ? stored : (sysDark ? "dark" : "light");
        applyTheme(initial, stored === null);
        log("pre-boot", { stored, sysDark, initial });
    } catch (e) {
        log("pre-boot FAIL", e);
    }

    // ---------- Body mirror ----------
    try {
        const mirror = new MutationObserver(function () {
            const t = root.getAttribute("data-theme");
            if (t && body() && body().getAttribute("data-theme") !== t) {
                body().setAttribute("data-theme", t);
            }
            // Keep the toggle button label/icon in sync with the resolved theme,
            // even when something other than frappe.ui.set_theme changed the attr.
            if (t === "light" || t === "dark") {
                try { updateToggleIcon(t); } catch(_) {}
            }
        });
        mirror.observe(root, { attributes: true, attributeFilter: ["data-theme", "data-theme-mode"] });
        log("mirror installed");
    } catch (e) {
        log("mirror FAIL", e);
    }

    // ---------- Patches ----------
    function installPatch() {
        if (typeof frappe === "undefined") return false;
        if (!frappe.ui) return false;
        const target = frappe.ui;
        const fn = target.set_theme;
        if (typeof fn !== "function") return false;
        if (target.__sarvasuite_patched === fn) return true;
        const orig = fn;
        function wrapper(theme) {
            try {
                var r = orig.apply(this, arguments);
                // After Frappe's original has set data-theme, resolve the new
                // effective theme and update our toggle button label/icon.
                try {
                    var now = root.getAttribute("data-theme") || theme;
                    if (now === "light" || now === "dark") updateToggleIcon(now);
                } catch(_) {}
                if (theme === "light" || theme === "dark") {
                    try { localStorage.setItem(STORE_KEY, theme); } catch(_) {}
                    if (typeof frappe.call === "function") {
                        try {
                            frappe.call({
                                method: "sarvasuite_app.boot.set_user_theme",
                                args: { theme: theme },
                                async: true
                            });
                        } catch(_) {}
                    }
                }
                return r;
            } catch (e) { log("wrapper error", e); throw e; }
        }
        try {
            Object.defineProperty(target, "set_theme", {
                value: wrapper, writable: true, configurable: true, enumerable: true
            });
            target.__sarvasuite_patched = wrapper;
            target.__sarvasuite_original = orig;
            log("PATCHED (defineProperty)");
            return true;
        } catch (e) {
            try { target.set_theme = wrapper; target.__sarvasuite_patched = wrapper; log("PATCHED (assign)"); return true; }
            catch (e2) { log("PATCH FAIL", e, e2); return false; }
        }
    }

    function bootAndPatch() {
        if (typeof frappe === "undefined" || !frappe.boot || !frappe.boot.user) {
            setTimeout(bootAndPatch, 100);
            return;
        }
        installPatch();
        setInterval(function () { try { installPatch(); } catch (e) { log("interval err", e); } }, 500);

        const want = localStorage.getItem(STORE_KEY);
        const have = (frappe.boot.user && frappe.boot.desk_theme) || frappe.boot.desk_theme || "";
        log("boot ready", { want: want, have: have });
        if ((want === "light" || want === "dark") && want !== have) {
            try {
                frappe.call({
                    method: "sarvasuite_app.boot.set_user_theme",
                    args: { theme: want },
                    async: true
                });
            } catch (e) { log("initial sync fail", e); }
        }
        function reassert() {
            try {
                if ((want === "light" || want === "dark") && root.getAttribute("data-theme") !== want) {
                    log("reassert", want, "→", root.getAttribute("data-theme"));
                    applyTheme(want, false);
                }
            } catch (e) { log("reassert err", e); }
        }
        setTimeout(reassert, 800);
        setTimeout(reassert, 2500);
        setTimeout(reassert, 6000);
    }
    bootAndPatch();

    // ---------- Toggle button ----------
    function updateToggleIcon(theme) {
        const btn = document.getElementById("sarvasuite-theme-toggle");
        if (!btn) return;
        const label = theme === "dark" ? "Light" : "Dark";
        const sunSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2"/><path d="M12 20v2"/><path d="m4.93 4.93 1.41 1.41"/><path d="m17.66 17.66 1.41 1.41"/><path d="M2 12h2"/><path d="M20 12h2"/><path d="m6.34 17.66-1.41 1.41"/><path d="m19.07 4.93-1.41 1.41"/></svg>';
        const moonSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z"/></svg>';
        btn.innerHTML = (theme === "dark" ? sunSvg : moonSvg) +
            '<span class="ss-toggle-label" style="margin-left:6px;font-weight:500;font-size:13px;">' + label + '</span>';
        btn.setAttribute("title", theme === "dark" ? "Switch to light mode" : "Switch to dark mode");
        btn.setAttribute("aria-label", btn.getAttribute("title"));
    }

    function mountToggle() {
        if (document.getElementById("sarvasuite-theme-toggle")) return;
        if (!document.body) { setTimeout(mountToggle, 100); return; }

        const btn = document.createElement("button");
        btn.id = "sarvasuite-theme-toggle";
        btn.type = "button";
        // Big, prominent, with a visible label "Dark"/"Light"
        btn.style.cssText = [
            "position:fixed",
            "top:10px",
            "right:18px",
            "z-index:2147483000",
            "display:inline-flex",
            "align-items:center",
            "justify-content:center",
            "height:34px",
            "min-width:90px",
            "padding:6px 12px",
            "border-radius:8px",
            "background:var(--ss-toggle-bg, #ffffff)",
            "color:var(--ss-toggle-fg, #1a1a1a)",
            "border:1.5px solid var(--ss-toggle-border, #1a1a1a)",
            "box-shadow:0 2px 6px rgba(0,0,0,0.18)",
            "cursor:pointer",
            "font-family:inherit",
            "font-size:13px",
            "transition:transform .12s, box-shadow .12s"
        ].join(";");
        btn.setAttribute("data-theme-toggle", "1");

        btn.addEventListener("mouseover", () => { btn.style.transform = "scale(1.04)"; });
        btn.addEventListener("mouseout", () => { btn.style.transform = "scale(1)"; });
        btn.addEventListener("click", function () {
            try {
                const cur = root.getAttribute("data-theme") || "light";
                const next = cur === "dark" ? "light" : "dark";
                if (typeof frappe !== "undefined" && frappe.ui && typeof frappe.ui.set_theme === "function") {
                    frappe.ui.set_theme(next);
                } else {
                    applyTheme(next, true);
                }
            } catch (e) { log("toggle fail", e); }
        });

        document.body.appendChild(btn);
        updateToggleIcon(root.getAttribute("data-theme") || "light");
        log("toggle mounted");
    }

    // Mount on every page including login
    if (document.body) {
        mountToggle();
    } else {
        document.addEventListener("DOMContentLoaded", mountToggle);
    }
    // Also try repeatedly in case body is replaced
    let mountAttempts = 0;
    const mountInterval = setInterval(function () {
        if (mountAttempts++ > 120) { clearInterval(mountInterval); return; }
        if (!document.getElementById("sarvasuite-theme-toggle") && document.body) {
            mountToggle();
        }
    }, 250);

    // ---------- System theme follow if user never picked ----------
    try {
        window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", function (e) {
            const stored = localStorage.getItem(STORE_KEY);
            if (stored === null || stored === undefined) {
                applyTheme(e.matches ? "dark" : "light", true);
            }
        });
    } catch (e) { log("mql fail", e); }

    window.__sarvasuite_theme = {
        set: (t) => { applyTheme(t, true); },
        get: () => localStorage.getItem(STORE_KEY),
        applyTheme: applyTheme,
        toggle: () => document.getElementById("sarvasuite-theme-toggle")?.click()
    };
    log("script end");
})();
